// File: CreatePost.js

import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import PageHeader1 from "../../components/common/PageHeader1";
import { submitPostApi, getPostByIdApi } from "../../services/Posts";
import { getCurrentUserId } from "../../utils/auth";

function CreatePost() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [imageFile, setImageFile] = useState(null);
  const [videoFile, setVideoFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewVideo, setPreviewVideo] = useState(null);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

 
  useEffect(() => {
    if (id) {
      
      (async () => {
        const res = await getPostByIdApi(id);
        console.log(res);
        if (res?.data) {
          const r = res.data;
          setValue("text", r.text);

          if (r.images?.length > 0) {
            setPreviewImage(r.images[0].url);
          }
          if (r.videos?.length > 0) {
            setPreviewVideo(r.videos[0].url);
          }
        }
      })();
    }
  }, [id, setValue]);

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("text", data.text);
    formData.append("userId", getCurrentUserId()); // replace with logged-in userId
    formData.append("action", id ? "edit" : "add");

    if (imageFile) formData.append("images", imageFile);
    if (videoFile) formData.append("videos", videoFile);
    if (id) formData.append("_id", id);

    const res = await submitPostApi(formData);
    if (res) {
      // toast.success(id ? "Post updated!" : "Post created!");
      if (!id) {
        reset();
        setImageFile(null);
        setVideoFile(null);
        setPreviewImage(null);
        setPreviewVideo(null);
      } else {
        navigate("/posts-list");
      }
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setVideoFile(null);
      setPreviewImage(URL.createObjectURL(file));
      setPreviewVideo(null);
    }
  };

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setVideoFile(file);
      setImageFile(null); 
      setPreviewVideo(URL.createObjectURL(file));
      setPreviewImage(null);
    }
  };

  return (
    <div className="container">
      <PageHeader1
        pagetitle={id ? "Edit Post" : "Add Post"}
        navigation="Posts"
        navlink="/posts-list"
        current={id ? "Edit" : "Add"}
      />

      <div className="col-lg-10 mx-auto">
        <div className="card p-4 shadow-sm">
          <form onSubmit={handleSubmit(onSubmit)} className="row g-3">
            <div className="col-12 text-center">
              <h2>{id ? "Edit Post" : "Add New Post"}</h2>
            </div>

            {/* Text */}
            <div className="col-12">
              <label className="form-label">Text</label>
              <textarea
                rows="3"
                className="form-control"
                {...register("text", { required: "Text is required" })}
              ></textarea>
              {errors.text && (
                <p className="text-danger">{errors.text.message}</p>
              )}
            </div>

            {/* Image Upload */}
            <div className="col-md-6">
              <label className="form-label">Image</label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                onChange={handleImageChange}
                disabled={videoFile !== null} // disable if video is selected
              />
              {previewImage && (
                <img
                  src={previewImage}
                  alt="Preview"
                  className="img-thumbnail mt-2"
                  style={{ maxHeight: "150px" }}
                />
              )}
            </div>

            {/* Video Upload */}
            <div className="col-md-6">
              <label className="form-label">Video</label>
              <input
                type="file"
                className="form-control"
                accept="video/*"
                onChange={handleVideoChange}
                disabled={imageFile !== null} // disable if image is selected
              />
              {previewVideo && (
                <video
                  src={previewVideo}
                  controls
                  className="mt-2"
                  style={{ maxHeight: "150px" }}
                />
              )}
            </div>

            {/* Actions */}
            <div className="col-12 text-center mt-4">
              <Button type="submit" className="btn btn-primary px-5 me-3">
                {id ? "Update" : "Save"}
              </Button>
              <Button
                variant="secondary"
                className="px-5"
                onClick={() => navigate("/posts-list")}
              >
                Back
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreatePost;
